// Copyright (C) 2022 TANNER AG

import useStore from "./usestore";
import shallow from "zustand/shallow";
import { useMemo } from "react";
import { TRANSLATION } from "../lib/translation";
import {notAvailableLocales} from "../lib/utils";

const SUPPORTED_LOCALES: readonly string[] = ["en", "de"];
const DEFAULT_COUNTRY = "DE";

const useLocale = () => {
    const [locale, setLocale] = useStore((state) => [state.locale ?? 'de', state.setLocale], shallow);
    const [country, setCountry] = useStore((state) => [state.country, state.setCountry], shallow);
    const [options, regionNames, languageNames] = useMemo(() => {
        return [
            TRANSLATION[locale],
            new Intl.DisplayNames([locale], { type: "region" }),
            new Intl.DisplayNames([locale], { type: "language" })
        ];
    }, [locale]);

    return {
        locale: !notAvailableLocales.includes(locale)? locale:"en",
        setLocale,
        country: country ?? DEFAULT_COUNTRY,
        setCountry,
        locales: SUPPORTED_LOCALES,
        regionNames,
        languageNames,
        ...options
    };
};

export default useLocale;
